import { Divider, Space, Steps, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { StepAssets } from '~/app/components/maintenance/preventive/wizard/StepAssets/StepAssets';
import { StepTasks } from '~/app/components/maintenance/preventive/wizard/StepTasks/StepTasks';
import { PlanWizardFooter } from './components/PlanWizardFooter/PlanWizardFooter';
import { PlanWizardReviewStep } from './components/PlanWizardReviewStep/PlanWizardReviewStep';
import { PlanWizardStepGeneral } from './components/PlanWizardStepGeneral/PlanWizardStepGeneral';
import { usePlanWizardPage } from './hooks/usePlanWizardPage';

const { Title, Paragraph } = Typography;

export function PlanWizardPage() {
  const { t } = useTranslation('maintenance');
  const {
    current,
    data,
    stepTitles,
    canProceed,
    conflictModalOpen,
    setConflictModalOpen,
    isAdvancingAssets,
    isCreatingWizard,
    isPreviewingWizard,
    reviewPreview,
    reviewPreviewError,
    handleChange,
    handleConflictsResolved,
    handleCancel,
    handleBack,
    handleNext,
    handleSave,
  } = usePlanWizardPage();

  const stepContent = [
    <PlanWizardStepGeneral key="general" data={data} onChange={handleChange} />,
    <StepTasks key="tasks" data={data} onChange={handleChange} />,
    <StepAssets
      key="assets"
      data={data}
      onChange={handleChange}
      isPreviewing={isPreviewingWizard || isAdvancingAssets}
      conflictModalOpen={conflictModalOpen}
      onConflictModalOpenChange={setConflictModalOpen}
      onConflictsResolved={handleConflictsResolved}
    />,
    <PlanWizardReviewStep
      key="review"
      data={data}
      preview={reviewPreview}
      isPreviewing={isPreviewingWizard}
      previewError={reviewPreviewError}
    />,
  ];

  return (
    <Space direction="vertical" size={24} style={{ width: '100%' }}>
      <div>
        <Title level={2} style={{ marginBottom: 8 }}>
          {t('wizard.title')}
        </Title>
        <Paragraph type="secondary">{t('wizard.previewOnlyHint')}</Paragraph>
      </div>

      <Steps current={current} items={stepTitles.map((title) => ({ title }))} />

      <div style={{ minHeight: 300 }}>{stepContent[current]}</div>

      <Divider />

      <PlanWizardFooter
        current={current}
        stepCount={stepTitles.length}
        canProceed={canProceed}
        isAdvancingAssets={isAdvancingAssets}
        isCreatingWizard={isCreatingWizard}
        isPreviewingWizard={isPreviewingWizard}
        onCancel={handleCancel}
        onBack={handleBack}
        onNext={() => void handleNext()}
        onSave={() => void handleSave()}
      />
    </Space>
  );
}
